import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createVNode as _createVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  class: /*#__PURE__*/_normalizeClass(`grid grid-cols-leftMargin
        gap-4
        md:gap-8
        items-center
        gap-y-6
        md:gap-y-10`)
}
const _hoisted_2 = ["src"]
const _hoisted_3 = { class: "col-start-2" }
const _hoisted_4 = { class: "font-bold text-lg md:text-2xl" }
const _hoisted_5 = { class: "text-sm md:text-base" }
const _hoisted_6 = { class: "text-sm md:text-base italic flex gap-3" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("span", { class: "not-italic" }, "|", -1)
const _hoisted_8 = {
  class: /*#__PURE__*/_normalizeClass(`md:col-start-2
          col-span-2
          md:col-span-1
          self-start
          gap-4
          flex flex-col
          text-base`)
}

import logoImg from "@/assets/logo.png";
import { useI18n } from "vue-i18n";
import SocialLinksList from "../organisms/SocialLinksList.vue";
import InfoPage from "../templates/InfoPage.vue";


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const { t } = useI18n();

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(InfoPage, { icon: "user" }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("img", {
          class: "col-start-1 w-20 md:w-32",
          src: _unref(logoImg)
        }, null, 8, _hoisted_2),
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, _toDisplayString(_unref(t)("about.name")), 1),
          _createElementVNode("div", _hoisted_5, _toDisplayString(_unref(t)("about.location")), 1),
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("span", null, _toDisplayString(_unref(t)("about.profession")), 1),
            _hoisted_7,
            _createElementVNode("span", null, _toDisplayString(_unref(t)("about.pronouns")), 1)
          ])
        ]),
        _createVNode(SocialLinksList, { class: "col-span-2 md:col-span-1 md:self-start" }),
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("div", null, _toDisplayString(_unref(t)("about.presentation.0")), 1),
          _createElementVNode("div", null, _toDisplayString(_unref(t)("about.presentation.1")), 1),
          _createElementVNode("div", null, _toDisplayString(_unref(t)("about.presentation.2")), 1),
          _createElementVNode("div", null, _toDisplayString(_unref(t)("about.presentation.3")), 1),
          _createElementVNode("div", null, _toDisplayString(_unref(t)("about.presentation.4")), 1)
        ])
      ])
    ]),
    _: 1
  }))
}
}

})